import * as React from 'react';

import DATA from '../data/pl/404.data'

import Layout from 'ssg-themes/src/themes/hijunior/components/Layout/Layout';
import NotFound from 'ssg-themes/src/themes/hijunior/modules/NotFound/NotFound';
import Seo from '../components/Seo/Seo';

const Error404Page = () => (<Layout>
  <Seo title="Błąd 404" meta={[{name: 'robots', content: 'noindex'}]} />
  <NotFound {...DATA}/>
</Layout>);

export default Error404Page;
